import $http from './http'
import config from './config'
export default {
    name: 'dingding',
    getUrl(url) {
        return config.getUrl(this.name, url);
    },
    synccompany(){
        return $http.get(this.getUrl('/common/SyncCompany'));
    }
}


// WEBPACK FOOTER //
// ./src/apis/dingdingapi.js